export const NEW_EMPTY_ROW = {
  __status: "__new",
  isNew: true,

  salesforceId: "",
  stateId: "",

  stateKey: null,
  status: "ACTIVE",
  stateDesc: null,
  stateDispValue: null,
  effectiveDate: null,
  countryId: null,
  stateGstCode: null,
};
